export default __webpack_public_path__ + "static/media/puzzlePieces.da099389.png";